/* Retail Fixtures Co – contact page (2-10-2026) */
(function () {
  var root = document.querySelector('[data-rfc-ct]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  var MSG = {
    product: { label: 'Your question', ph: 'e.g. Will this fit a 1.4m bay? Is it available in black?' },
    bulk: { label: 'Your message', ph: 'Anything else we should know — finishes, colours, delivery access, budget.' },
    fitout: { label: 'Tell us about the project', ph: 'e.g. new convenience store, wall and gondola shelving, 2 checkouts, trolley bay.' },
    order: { label: 'Your message', ph: 'What has happened and what you need from us.' },
    other: { label: 'Your message', ph: 'How can we help?' }
  };

  var select = $('[data-rfc-ct-select]');
  var current = root.getAttribute('data-default') || 'bulk';

  function setTopic(key, scroll) {
    if (!MSG[key]) key = 'bulk';
    current = key;
    $$('.rfc-ct__topic').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-topic') === key ? 'true' : 'false'); });
    if (select) {
      $$('option', select).forEach(function (o) { if (o.getAttribute('data-topic') === key) select.value = o.value; });
    }
    $$('.rfc-ct__grp').forEach(function (g) {
      var on = g.getAttribute('data-for') === key;
      g.hidden = !on;
      g.disabled = !on;
    });
    var ml = $('[data-rfc-ct-msgl]'); if (ml) ml.textContent = MSG[key].label;
    var mg = $('[data-rfc-ct-msg]'); if (mg) mg.placeholder = MSG[key].ph;
    $$('.rfc-ct__grp[hidden] [aria-invalid]').forEach(clearErr);
    if (scroll) {
      var f = $('#rfc-ct-message');
      if (f) {
        var r = f.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.6 || r.top < 0) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
  $$('.rfc-ct__topic').forEach(function (b) {
    b.addEventListener('click', function () { setTopic(b.getAttribute('data-topic'), !!$('#rfc-ct-form select')); });
  });
  if (select) select.addEventListener('change', function () {
    var o = select.options[select.selectedIndex];
    setTopic(o && o.getAttribute('data-topic'), false);
  });

  /* call me back makes phone required */
  var phone = $('#rfc-ct-phone');
  $$('input[name="contact[Reply by]"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var call = $('[data-rfc-ct-call]');
      var need = !!(call && call.checked);
      if (phone) phone.required = need;
      var star = $('[data-rfc-ct-phreq]'); if (star) star.hidden = !need;
      if (!need && phone) clearErr(phone);
    });
  });

  /* validation */
  function errEl(input) { var id = input.getAttribute('aria-describedby'); return id ? document.getElementById(id) : null; }
  function setErr(input, msg) { input.setAttribute('aria-invalid', 'true'); var e = errEl(input); if (e) { e.textContent = msg; e.hidden = false; } }
  function clearErr(input) { input.removeAttribute('aria-invalid'); var e = errEl(input); if (e) { e.textContent = ''; e.hidden = true; } }
  function check(input) {
    var v = (input.value || '').trim();
    var label = input.id === 'rfc-ct-email' ? 'your email address' : input.id === 'rfc-ct-phone' ? 'a phone number so we can call you back' : input.id === 'rfc-ct-name' ? 'your name' : input.id === 'rfc-ct-items' ? 'the products and quantities' : input.id === 'rfc-ct-ord' ? 'your order number' : 'your message';
    if ((input.required || input.hasAttribute('data-rfc-ct-need')) && !v) { setErr(input, 'Please add ' + label + '.'); return false; }
    if (input.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { setErr(input, 'Please enter an email like name@company.co.uk.'); return false; }
    clearErr(input);
    return true;
  }
  var form = $('#rfc-ct-form');
  if (form && !$('[data-rfc-ct-ok]')) {
    form.addEventListener('submit', function (e) {
      var fields = $$('#rfc-ct-name, #rfc-ct-email, #rfc-ct-msg', form);
      if (phone && phone.required) fields.push(phone);
      $$('.rfc-ct__grp:not([hidden]) [data-rfc-ct-need]', form).forEach(function (f) { fields.push(f); });
      var first = null;
      fields.forEach(function (f) { if (!check(f) && !first) first = f; });
      if (first) { e.preventDefault(); first.focus(); return; }
      var btn = $('.rfc-ct__send', form);
      if (btn) { btn.disabled = true; btn.firstChild.textContent = 'Sending… '; }
    });
    form.addEventListener('input', function (e) { if (e.target.getAttribute('aria-invalid') === 'true') check(e.target); });
  }

  /* posted / error state: bring it into view */
  var ok = $('[data-rfc-ct-ok]') || $('[data-rfc-ct-err]');
  if (ok) { var sec = $('#rfc-ct-message'); if (sec) sec.scrollIntoView({ block: 'start' }); ok.focus({ preventScroll: true }); }

  /* copy company details */
  var copyBtn = $('[data-rfc-ct-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var co = $('[data-rfc-ct-co]');
    var lines = [];
    var t = $('.rfc-ct__trading', co); if (t) lines.push(t.textContent.trim());
    var a = $('.rfc-ct__addr span', co); if (a) lines.push(a.innerText.replace(/\s*\n\s*/g, ' ').trim());
    $$('.rfc-ct__ids div', co).forEach(function (d) { lines.push(d.textContent.replace(/\s+/g, ' ').replace(':', ': ').replace(/\s+/g, ' ').trim()); });
    var call = $('.rfc-ct__call b'); if (call) lines.push('Tel: ' + call.textContent.trim());
    var mail = $('.rfc-ct__mail b'); if (mail) lines.push('Email: ' + mail.textContent.trim());
    var text = lines.join('\n');
    var lab = $('[data-rfc-ct-copyl]'), live = $('[data-rfc-ct-live]');
    var done = function () {
      copyBtn.classList.add('is-done'); if (lab) lab.textContent = 'Copied'; if (live) live.textContent = 'Company details copied';
      setTimeout(function () { copyBtn.classList.remove('is-done'); if (lab) lab.textContent = 'Copy company details'; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () {});
    else { var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (err) {} ta.remove(); }
  });

  /* open now badge (UK time, Mon–Fri) */
  var badge = $('[data-rfc-ct-open]');
  if (badge) {
    var oh = parseFloat(root.getAttribute('data-open')) || 8.5, ch = parseFloat(root.getAttribute('data-close')) || 17;
    var fmt = function (h) { var m = Math.round((h % 1) * 60), H = Math.floor(h); return (H < 10 ? '0' : '') + H + ':' + (m < 10 ? '0' : '') + m; };
    var paint = function () {
      var day, hr;
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
        var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
        day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(g('weekday'));
        hr = (parseInt(g('hour'), 10) % 24) + parseInt(g('minute'), 10) / 60;
      } catch (err) { var d = new Date(); day = d.getDay(); hr = d.getHours() + d.getMinutes() / 60; }
      var wk = day >= 1 && day <= 5;
      if (wk && hr >= oh && hr < ch) { badge.textContent = 'Open now · until ' + fmt(ch); badge.classList.remove('is-closed'); }
      else {
        var when = (wk && hr < oh) ? 'today ' + fmt(oh) : (day >= 1 && day <= 4) ? 'tomorrow ' + fmt(oh) : 'Monday ' + fmt(oh);
        badge.textContent = 'Closed · opens ' + when; badge.classList.add('is-closed');
      }
      badge.hidden = false;
    };
    paint(); setInterval(paint, 60000);
  }

  /* first topic: ?topic= in the link, else the section setting */
  var q = '';
  try { q = new URLSearchParams(location.search).get('topic') || ''; } catch (err) {}
  setTopic(MSG[q] ? q : current, false);
})();
